import React from 'react';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/actionOverview-14@3x.png';

export const DoItAnywayStep = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading small>Developing Flexibility with Emotions</S.StepHeading>
                <S.StepHeading>Do it Anyway!</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    Sometimes we don’t do things we care about because it brings up a negative
                    emotion, like fear or anxiety. For example, we might want to develop better
                    relationships with our coworkers but we won’t ask a new coworker to eat lunch
                    with us because we’re scared they might say no. Or, we might plan to go for a
                    run but we feel tired or lazy so we don't. Practicing psychological flexibility
                    means doing it anyway, because it matters to us.We'll usually learn that it's
                    not as difficult as we thought it would be and that it gets easier over time!
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
);
